import { FC, useSyncExternalStore } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Image } from '@frontend/design-system';
import { ScrollCueStore } from './scroll-cue.store';
import { containerStyle, getAnimationStyles, imageContainerStyle } from './scroll-cue.styles';

export interface ScrollCueProps {
  store: ScrollCueStore;
  onClickScrollIcon: () => void;
}

const ScrollCue: FC<ScrollCueProps> = ({ store, onClickScrollIcon }) => {
  const { t } = useTranslation('digital-forms-experience');
  const shouldShow = useSyncExternalStore(store.subscribe, store.getSnapshot);

  return (
    <div id='scroll-cue'>
      <button
        type='button'
        css={[containerStyle, getAnimationStyles(shouldShow)]}
        onClick={onClickScrollIcon}
        aria-label={t('scrollDown')}
        data-trackingid='forms-scroll-cue-button'
        style={{ pointerEvents: shouldShow ? 'auto' : 'none' }}
      >
        <Image
          src='/images/scroll-down-icon.gif'
          alt=''
          animate={false}
          initial={false}
          containerStyle={imageContainerStyle}
        />
      </button>
    </div>
  );
};

export default ScrollCue;
